module.exports = __webpack_public_path__ + "img/gift.bd33e3a2.png";